function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import React from "react";
import variables from "./variables.js";
import MATCHES from "./matches.js";
var useMedia = function useMedia(query) {
  var _React$useState = React.useState(MATCHES.NOT_SURE),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    matches = _React$useState2[0],
    setMatches = _React$useState2[1];
  var media = React.useRef();
  var handleMediaChange = function handleMediaChange(mediaEvent) {
    setMatches(mediaEvent.matches ? MATCHES.YES : MATCHES.NO);
  };
  React.useEffect(function () {
    media.current = _globalThis.matchMedia(query);
    handleMediaChange(media.current);
    media.current.addEventListener('change', handleMediaChange);
    return function () {
      media.current.removeEventListener('change', handleMediaChange);
    };
  }, [query]);
  return {
    matches: matches,
    yes: matches === MATCHES.YES,
    no: matches === MATCHES.NO,
    notSure: matches === MATCHES.NOT_SURE
  };
};
export var useMobileMedia = function useMobileMedia() {
  return useMedia("(".concat(variables.inMobile, ")"));
};
export var useDesktopMedia = function useDesktopMedia() {
  return useMedia("(".concat(variables.inDesktop, ")"));
};
var strictGet = function strictGet(obj, key) {
  var keysAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Object$keys(obj);
  if (!_includesInstanceProperty(keysAllowed).call(keysAllowed, key)) throw new Error("Invalid key: ".concat(key.toString(), ". Valid keys: ").concat(keysAllowed.join(', ')));
  return obj[key];
};
var screenSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export var useMediaScreenMin = function useMediaScreenMin(screenSize) {
  return useMedia("(min-width: ".concat(strictGet(variables, screenSize, screenSizes), ")"));
};
export var useMediaScreenMax = function useMediaScreenMax(screenSize) {
  return useMedia("(max-width: ".concat(strictGet(variables, "".concat(screenSize, "Max"), ['xsMax', 'smMax', 'mdMax', 'lgMax', 'xlMax']), ")"));
};
export default useMedia;